export const PENDING = 'pending';
export const FAILURE = 'failure';
export const SUCCESS = 'success';
export const UNCALLED = 'uncalled';
